<template>
  <span :class="[
    'inline-flex items-center border font-medium whitespace-nowrap select-none',
    sizeClasses[size],
    variantClasses[variant],
  ]">
    <span v-if="$slots.leading || showDot" class="inline-flex shrink-0">
      <slot name="leading">
        <span :class="['rounded-full bg-current', dotSizeClasses[size]]"></span>
      </slot>
    </span>
    <slot />
  </span>
</template>

<script>
export default {
  name: 'AppBadge',
  props: {
    variant: {
      type: String,
      default: 'secondary',
      validator: v => ['primary', 'secondary', 'success', 'warning', 'danger', 'info'].includes(v),
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['xs', 'sm', 'md', 'lg', 'xl'].includes(v),
    },
    showDot: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sizeClasses() {
      return {
        xs: 'px-2 py-0.5 text-xs rounded-md gap-1',
        sm: 'px-2.5 py-1 text-xs rounded-lg gap-1.5',
        md: 'px-3 py-1 text-sm rounded-lg gap-1.5',
        lg: 'px-3 py-1.5 text-sm rounded-xl gap-1.5',
        xl: 'px-4 py-2 text-sm rounded-xl gap-2',
      };
    },
    dotSizeClasses() {
      return {
        xs: 'size-1.5',
        sm: 'size-2',
        md: 'size-2',
        lg: 'size-2.5',
        xl: 'size-2.5',
      };
    },
    variantClasses() {
      return {
        primary: 'border-indigo-400/30 bg-indigo-500/16 text-indigo-200',
        secondary: 'border-white/15 bg-white/5 text-gray-300',
        success: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-200',
        warning: 'border-amber-500/40 bg-amber-500/10 text-amber-200',
        danger: 'border-red-500/35 bg-red-500/12 text-red-300',
        info: 'border-sky-500/35 bg-sky-500/12 text-sky-200',
      };
    },
  },
};
</script>
